import { render, staticRenderFns } from "./LeaderBoardItem.vue?vue&type=template&id=62bcc302&scoped=true&"
import script from "./LeaderBoardItem.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardItem.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardItem.vue?vue&type=style&index=0&id=62bcc302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bcc302",
  null
  
)

export default component.exports